import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Eye, EyeSlash } from '@phosphor-icons/react';
import axios from 'axios';
import { toast } from 'sonner';
import { useAuth } from '../contexts/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminChangeEmail = ({ onBack }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [newEmail, setNewEmail] = useState('');
  const [newResendKey, setNewResendKey] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!password) {
      toast.error('Enter your admin password');
      return;
    }
    if (!newEmail) {
      toast.error('Enter new email address');
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${API}/admin/update-email`, {
        admin_id: user.id,
        password: password,
        new_email: newEmail,
        new_resend_key: newResendKey || undefined
      });
      toast.success('Email updated successfully!');
      handleBackClick();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to update email');
    }
    setLoading(false);
  };

  const handleBackClick = () => {
    if (onBack) {
      onBack();
    } else {
      navigate('/admin-settings');
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-[#075E54] text-white px-4 py-3 flex items-center gap-3">
        <button onClick={handleBackClick} className="p-1"><ArrowLeft size={24} /></button>
        <h1 className="text-lg font-semibold">Change Email & API Key</h1>
      </div>

      <div className="p-4 space-y-4">
        <div className="bg-white rounded-xl p-4 shadow-sm space-y-4">
          <div>
            <label className="text-sm font-medium text-gray-700 mb-1 block">Admin Password</label>
            <div className="relative">
              <input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter admin password"
                className="w-full px-3 py-2 border rounded-lg pr-10 outline-none focus:border-[#075E54]"
              />
              <button onClick={() => setShowPassword(!showPassword)} className="absolute right-3 top-2.5 text-gray-500">
                {showPassword ? <EyeSlash size={20} /> : <Eye size={20} />}
              </button>
            </div>
          </div>

          <div>
            <label className="text-sm font-medium text-gray-700 mb-1 block">New Email Address</label>
            <input
              type="email"
              value={newEmail}
              onChange={(e) => setNewEmail(e.target.value)}
              placeholder="Enter new email"
              className="w-full px-3 py-2 border rounded-lg outline-none focus:border-[#075E54]"
            />
          </div>

          <div>
            <label className="text-sm font-medium text-gray-700 mb-1 block">Resend API Key (optional)</label>
            <input
              type="text"
              value={newResendKey}
              onChange={(e) => setNewResendKey(e.target.value)}
              placeholder="Enter new Resend API key (leave empty to keep current)"
              className="w-full px-3 py-2 border rounded-lg outline-none focus:border-[#075E54]"
            />
          </div>

          <button
            onClick={handleSubmit}
            disabled={loading || !password || !newEmail}
            className="w-full py-3 bg-[#075E54] text-white rounded-lg font-semibold hover:bg-[#064E46] disabled:opacity-50"
          >
            {loading ? 'Updating...' : 'Update Email & Key'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminChangeEmail;
